import { jsx } from "react/jsx-runtime";
import { Button, ButtonSize, HoverStyles } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useForcedState, ForcedState } from "../../../../../contexts/forced-state-context.js";
import { classes } from "./next-button.st.css";
const NextButton = ({
  nextText,
  className,
  onClick
}) => {
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.NEXT_BUTTON_HOVER);
  return /* @__PURE__ */ jsx(
    Button,
    {
      className: classNames(
        classes.nextButton,
        {
          [classes.nextButtonHover]: hover
        },
        className
      ),
      hoverStyle: HoverStyles.underline,
      upgrade: true,
      wrapContent: true,
      size: ButtonSize.large,
      onClick,
      "data-hook": "next-button",
      children: nextText
    }
  );
};
export {
  NextButton as default
};
//# sourceMappingURL=next-button.js.map
